__turbopack_context__.v({
  "eyeBrow": "channelStripSkeleton-module-scss-module__lrDWgG__eyeBrow",
  "leftContentWrapper": "channelStripSkeleton-module-scss-module__lrDWgG__leftContentWrapper",
  "leftImage": "channelStripSkeleton-module-scss-module__lrDWgG__leftImage",
  "leftSideContent": "channelStripSkeleton-module-scss-module__lrDWgG__leftSideContent",
  "mainWrapper": "channelStripSkeleton-module-scss-module__lrDWgG__mainWrapper",
  "rightContentWrapper": "channelStripSkeleton-module-scss-module__lrDWgG__rightContentWrapper",
  "rightImage": "channelStripSkeleton-module-scss-module__lrDWgG__rightImage",
  "rightSideContent": "channelStripSkeleton-module-scss-module__lrDWgG__rightSideContent",
  "secondarySubTitle": "channelStripSkeleton-module-scss-module__lrDWgG__secondarySubTitle",
  "slideEffect": "channelStripSkeleton-module-scss-module__lrDWgG__slideEffect",
  "subTitle": "channelStripSkeleton-module-scss-module__lrDWgG__subTitle",
  "title": "channelStripSkeleton-module-scss-module__lrDWgG__title",
});
